import { Button, Grid, Stack, Switch, Typography } from '@mui/material';
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import { CustomDatePicker, CustomTextField, CustomInputLabel, CustomButton, InputProps, StyledCard, StyledCardTitle, FlexDiv } from 'custom/components';
import dayjs from 'dayjs';
import React from 'react';
import developerStyles from './developer.module.css';
import styles from '../../../custom/style.module.css';
import cookies from 'utils/cookies';

const Developer = (props) => {
  const getLable = (key) => {
    switch (key) {
      case 'ffm_flight_no':
        return 'FFM Flight No';
      case 'ffm_flight_date':
        return 'FFM Flight Date';
      case 'ffm_edit':
        return 'FFM Edit';
      case 'buildup':
        return 'Buildup Tab && Loading Accessories';
      case 'import':
        return 'Import Notification';
      case 'doc_fwb':
        return 'Doc FWB';
      case 'service':
        return 'Service Catalog';
      default:
        return key;
    }
  };

  const getDesc = (key) => {
    switch (key) {
      case 'ffm_flight_no':
        return 'Enable/Disable FFM Flight No validation FFM upload in Flight Folder';
      case 'ffm_flight_date':
        return 'Enable/Disable FFM Flight Date validation FFM upload in Flight Folder';
      case 'buildup':
        return 'Enable/Disable Buildup Tab in Flight Folder and Export operation in admin';
      case 'import':
        return 'Enable/Disable Import Notification in Flight Folder and Inport operation in admin';
      case 'doc_fwb':
        return 'Enable/Disable AWB Viewer in navigation and Docs Stream for all users';
      case 'service':
        return 'Enable/Disable Service Catalog Tab in admin';
      default:
        return '';
    }
  };

  const companySettings = props.config.filter((item) => item.companyId && !item.stationId && item.key !== 'mail_bounce' && item.key !== 'doc_fwb');
  const docFwb = props.config.find((item) => item.key === 'doc_fwb') || {
    id: 'doc_fwb',
    key: 'doc_fwb',
    value: { data: 'false' },
  };
  companySettings.push(docFwb);
  const ffm_flight_no = props.config.filter((item) => item.stationId && ['ffm_flight_no'].includes(item.key));
  const ffm_flight_date = props.config.filter((item) => item.stationId && ['ffm_flight_date'].includes(item.key));

  const getStatus = (...keys) => {
    const status = keys.find((key) => props.progress?.[key]);
    return status ? props.progress[status] : '-';
  };

  const userSections = [
    {
      title: 'Authorized Users',
      list: props.userList
    },
    {
      title: 'Flight Reports Approvers',
      list: props.approverList
    },
    {
      title: 'Non Commercial Contract Importers',
      list: props.nonCommercialList
    }
  ];

  const adminImports = [
    {
      key: 'airlines',
      title: 'Airlines',
      onClick: props.importAirlines
    },
    {
      key: 'products',
      title: 'Products',
      onClick: props.importProducts
    },
    {
      key: 'checklists',
      title: 'Checklists',
      onClick: props.importChecklists
    },
    {
      key: 'contracts',
      title: 'Contracts',
      onClick: props.importContracts
    }
  ];

  const dateValue = (value) => (value ? dayjs(value) : null);

  return (
    <div className={developerStyles.page}>

      <Grid container spacing={3}>
        <Grid item xs={12} lg={4}>
          <StyledCard className={styles.h100}>
            <FlexDiv><StyledCardTitle>Flight Folder (Company Level)</StyledCardTitle></FlexDiv>
            <div className={developerStyles.card}>
              <div className={developerStyles.switchList}>
                {companySettings.map((item, index) => {
                  let ignore = ['custom_status_codes', 'custom_status_check_interval'];
                  if (ignore.includes(item.key)) return null;
                  return (
                    <div key={index} className={developerStyles.switchRow}>
                      <div>
                        <Typography component='h3' className={developerStyles.rowTitle}>{getLable(item.key)}</Typography>
                        <Typography component='p' className={developerStyles.rowDescription}>{getDesc(item.key)}</Typography>
                      </div>
                      <Switch
                        name={item.id}
                        defaultChecked={item?.value?.data ? item.value.data === 'true' : false}
                        onChange={props.onChange}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </StyledCard>
        </Grid>

        <Grid item xs={12} lg={4}>
          <StyledCard className={styles.h100}>
            <FlexDiv><StyledCardTitle>Flight Data API (Global)</StyledCardTitle></FlexDiv>
            <div className={developerStyles.card}>
              <div className={developerStyles.switchList}>
                {props.stations.map((item, index) => (
                  <div key={index} className={developerStyles.switchRow}>
                    <Typography component='h3' className={developerStyles.rowTitle}>{getLable(item)}</Typography>

                    <Switch
                      name={item}
                      defaultChecked={!!props.config?.find((c) => c.key === 'flight_api' && c.value && c.value?.includes(item))}
                      onChange={props.onChangeStation}
                    />
                  </div>
                ))}
              </div>
            </div>
          </StyledCard>
        </Grid>

        <Grid item xs={12} lg={4}>
          <StyledCard className={styles.h100}>
            <FlexDiv><StyledCardTitle>{cookies.get('station_code')}</StyledCardTitle></FlexDiv>
            <div className={developerStyles.card}>
              <div className={developerStyles.switchList}>
                <div className={developerStyles.switchRow}>
                  <div>
                    <Typography component='h3' className={developerStyles.rowTitle}>{getLable('ffm_flight_no')}</Typography>
                    <Typography component='p' className={developerStyles.rowDescription}>{getDesc('ffm_flight_no')}</Typography>
                  </div>
                  {ffm_flight_no && <Switch
                    name={'ffm_flight_no'}
                    checked={ffm_flight_no?.[0]?.value?.data === 'true'}
                    onChange={props.onChange}
                  />}
                </div>

                <div className={developerStyles.switchRow}>
                  <div>
                    <Typography component='h3' className={developerStyles.rowTitle}>{getLable('ffm_flight_date')}</Typography>
                    <Typography component='p' className={developerStyles.rowDescription}>{getDesc('ffm_flight_date')}</Typography>
                  </div>
                  {ffm_flight_date && <Switch
                    name={'ffm_flight_date'}
                    checked={ffm_flight_date?.[0]?.value?.data === 'true'}
                    onChange={props.onChange}
                  />}
                </div>
              </div>
            </div>
          </StyledCard>
        </Grid>

        {userSections.map((section) => (
          <Grid item xs={12} md={4} key={section.title}>
            <StyledCard className={styles.h100}>
              <FlexDiv><StyledCardTitle>{section.title}</StyledCardTitle></FlexDiv>
              <div className={developerStyles.card}>
                <ul className={developerStyles.userList}>
                  {section.list.map((item, index) => (
                    <li key={index} className={developerStyles.userItem}>{item.username}</li>
                  ))}
                </ul>
              </div>
            </StyledCard>
          </Grid>
        ))}

        <Grid item xs={12}>

          <StyledCard className={developerStyles.card}>
            <FlexDiv><StyledCardTitle>Import From Production</StyledCardTitle></FlexDiv>
            <div className={developerStyles.importBlock}>
              <Typography component='h3' className={developerStyles.blockTitle}>Admin Imports</Typography>
              <Grid container spacing={2} className={developerStyles.importGrid}>
                {adminImports.map((item) => (
                  <Grid item xs={12} sm={6} md={4} lg={12/5} key={item.key}>
                    <div className={developerStyles.importRow}>
                      <Typography component='h4' variant='h4'>{item.title}</Typography>
                      <Button size='small' variant='contained' onClick={item.onClick}>Import</Button>
                      <p className={developerStyles.status}>Status: <span>{getStatus(item.key)}</span></p>
                    </div>
                  </Grid>
                ))}

                <Grid item xs={12} sm={6} md={4} lg={12/5}>
                  <div className={developerStyles.importRow}>
                    <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={2}>
                      <Typography component='h4' variant='h4'>{'Consignee'}</Typography>
                      <Button
                        size='small'
                        variant='outlined'
                        component='label'
                        startIcon={<UploadFileRoundedIcon fontSize='small' className={developerStyles.uploadIcon} />}
                      >
                        <input
                          hidden
                          type='file'
                          accept='.json'
                          onChange={props.handleConsigneeFileChange}
                        />
                      </Button>
                    </Stack>
                    <Button size='small' variant='contained' onClick={props.importConsignee}>Import</Button>
                    <p className={developerStyles.status}>Status: <span>{getStatus('consignee')}</span></p>
                  </div>
                </Grid>
              </Grid>
            </div>

            <div className={developerStyles.importBlock}>
              <Typography component='h3' className={developerStyles.blockTitle}>Flights</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <div className={developerStyles.fieldGroup}>
                    <CustomInputLabel component='label' htmlFor='airline'>Airline</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='airline'
                      name='airline'
                      value={props.searchOptions.airline}
                      onChange={(e) => props.handleChange(e, 'airline')}
                    />
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>

                  <div className={developerStyles.fieldGroup}>
                    <CustomInputLabel component='label' htmlFor='from'>From</CustomInputLabel>
                    <CustomDatePicker
                      slotProps={{
                        textField: {
                          ...InputProps,
                          id: 'from',
                          placeholder: 'Date',
                          fullWidth: true
                        },
                      }}
                      format='DD MMM YYYY'
                      name='from'
                      value={dateValue(props.searchOptions.from)}
                      onChange={(e) => props.handleChange(e, 'from')}
                    />
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <div className={developerStyles.fieldGroup}>
                    <CustomInputLabel component='label' htmlFor='to'>To</CustomInputLabel>
                    <CustomDatePicker
                      slotProps={{
                        textField: {
                          ...InputProps,
                          id: 'to',
                          placeholder: 'Date',
                          fullWidth: true
                        },
                      }}
                      format='DD MMM YYYY'
                      name='to'
                      value={dateValue(props.searchOptions.to)}
                      onChange={(e) => props.handleChange(e, 'to')}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <div className={developerStyles.actionGroup}>
                    <CustomButton size='small' fullWidth variant='contained' onClick={props.importFlights}>Import Flights</CustomButton>
                  </div>
                </Grid>
              </Grid>
            </div>

            <div className={developerStyles.importBlock}>
              <Typography component='h3' className={developerStyles.blockTitle}>Clear Flight</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <div className={developerStyles.fieldGroup}>
                    <CustomInputLabel component='label' htmlFor='flight_no'>Flight No.</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='flight_no'
                      name='flight_no'
                      value={props.searchOptions.flight_no}
                      onChange={(e) => props.handleChange(e, 'flight_no')}
                    />
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <div className={developerStyles.fieldGroup}>
                    <CustomInputLabel component='label' htmlFor='date'>Date</CustomInputLabel>
                    <CustomDatePicker
                      slotProps={{
                        textField: {
                          ...InputProps,
                          id: 'date',
                          placeholder: 'Date',
                          fullWidth: true
                        },
                      }}
                      format='DD MMM YYYY'
                      name='date'
                      value={dateValue(props.searchOptions.date)}
                      onChange={(e) => props.handleChange(e, 'date')}
                    />
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3/2}>

                  <div className={developerStyles.fieldGroup}>
                    <CustomInputLabel component='label' htmlFor='org'>Org</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='org'
                      name='org'
                      value={props.searchOptions.org}
                      onChange={(e) => props.handleChange(e, 'org')}
                    />
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3/2}>

                  <div className={developerStyles.fieldGroup}>
                    <CustomInputLabel component='label' htmlFor='dest'>Dest</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='dest'
                      name='dest'
                      value={props.searchOptions.dest}
                      onChange={(e) => props.handleChange(e, 'dest')}
                    />
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <div className={developerStyles.actionGroup}>
                    <CustomButton size='small' fullWidth variant='contained' color='error' onClick={props.clearFlights}>Clear Flight</CustomButton>
                  </div>
                </Grid>
              </Grid>
            </div>
          </StyledCard>

        </Grid>
      </Grid>
    </div>
  );
};

export default Developer;